/**
 * pricebooks.ts — static per-supplier price books for Supplier Price Books page.
 * Keyed by supplierId → productCode → unit price (ex GST).
 * Cross-supplier pricing included so "vs Primary" comparison is meaningful.
 */
export const PRICE_BOOKS: Record<string, Record<string, number>> = {
  sup11: {
    'QSW-SVC': 585.00,
  },
  sup12: {
    'HC-WDB-06/16':  1.29,
    '06FH':          9.17,
    'DFBANJO-0614M': 11.71,
    'DFBANJO-0612M': 24.92,
    'BR-HTHT-0608':  6.87,
    '05FH':          9.50,
    'HC-WDN-10/16':  1.65,
  },
  sup13: {
    '05FH':          9.20,
    'HC-WDN-10/16':  1.57,
    'HC-WDB-06/16':  1.35,
    '06FH':          9.90,
  },
  sup14: {
    'SGA12SGSD': 2.20,
    'PACMC2240': 1.41,
    'PACMC1300': 0.94,
  },
  sup15: {
    'LY-FK00147': 3750.00,
  },
  sup16: {
    'MB205':          8.05,
    'FM40':          23.00,
    'FREIGHT-METRO': 11.00,
    'SGA12SGSD':      2.45,
  },
  sup17: {
    '90179-22029': 6.01,
    '41214-60020': 11.98,
    '90366-33006': 43.90,
    '41231-60040': 26.02,
    '90366-40111': 68.50,
    '90311-45036': 26.50,
  },
  sup18: {
    'MSF-ALLY-TRI-3': 338.00,
    'IMAGE-135115':   395.00,
  },
  sup19: {
    '8T4131':       3.40,
    'S-140-080-16': 9.05,
    '2135007':      7.79,
    '5416882':    375.55,
  },
  sup20: {
    'IMAGE-135115': 379.00,
    'IMAGE-132123': 335.00,
    'FREIGHT-IST':   75.00,
  },
  sup21: {
    'QFT-30L-ENVO': 9900.00,
  },
};
